module.exports = __webpack_public_path__ + "img/bg-head.0bb4697a.png";